import { LOT_METADATA_REPORT_READY, LOT_METADATA_REPORT_CLEAR } from '../constants';

const initialState = {
  lastResult: null
};

const lotMetadataReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOT_METADATA_REPORT_READY:
      return {
        ...state,
        lastResult: { ...action.payload, receivedAt: Date.now() }
      };
    case LOT_METADATA_REPORT_CLEAR:
      return { ...state, lastResult: null };
    default:
      return state;
  }
};

export default lotMetadataReportReducer;
